import { Box } from "@mui/material";
import CustomerIcon from "../../../../Assets/Icons/customer-icon.png";

const getColor = (status) => {
  switch (status) {
    case "On Hold":
      return "#F45B69";

    case "In Queue":
      return "#5D6679";

    case "In Progress":
      return "#1570EF";

    case "Completed":
      return "#12B76A";

    default:
      return "";
  }
};

export const getColumns = (hasStatusOnHold) => [
  {
    field: "showCustomerIcon",
    headerName: "",
    width: 30,
    renderCell: (params) =>
      params.row.isPriorityOrder ? (
        <img src={CustomerIcon} width={24} height={24} alt="Customer Icon" />
      ) : (
        ""
      ),
  },
  {
    field: "sssJobNo",
    headerName: "SSS Job No",
    width: 140,
  },
  { field: "custOrder", headerName: "Cust Order", width: 140 },
  { field: "customer", headerName: "Customer", width: 200 },
  { field: "orderDate", headerName: "Order Date", width: 150 },
  { field: "orderLine", headerName: "Order Line", width: 100, align: "center" },
  {
    field: "pickUpQty",
    headerName: "Pick Up Qty",
    width: 100,
    align: "center",
  },
  { field: "cutoff", headerName: "Cutoff", width: 180 },
  {
    field: "picker",
    headerName: "Picker",
    width: 150,
    renderCell: (params) => {
      const picker = params.value.name;

      return <>{picker}</>;
    },
  },
  {
    field: "status",
    headerName: "Status",
    width: 130,
    renderCell: (params) => {
      const status = params.value;

      return (
        <Box
          sx={{
            color: getColor(status),
          }}
        >
          {status}
        </Box>
      );
    },
  },
  ...(hasStatusOnHold
    ? [
        {
          field: "reason",
          headerName: "Reason",
          width: 140,
          renderCell: (params) => {
            return params.row.status === "On Hold" ? "Out of Stock" : "";
          },
        },
      ]
    : []),
];
